import { ITaskRuleInput } from '@common/interfaces/taskRule'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'taskRules'

export const [LIST_TASK_RULES_REQUEST, LIST_TASK_RULES_SUCCESS, LIST_TASK_RULES_FAILURE] =
  createRequestTypes(prefix, 'LIST_TASK_RULES')

/** A project's rules, or the viewer's own My Tasks rules when `projectId` is null. */
export const listTaskRules = createAction((projectId: string | null) => ({
  type: [LIST_TASK_RULES_REQUEST, LIST_TASK_RULES_SUCCESS, LIST_TASK_RULES_FAILURE],
  promise: (api: IApi) => api.taskRules.list(projectId),
}))

export const [CREATE_TASK_RULE_REQUEST, CREATE_TASK_RULE_SUCCESS, CREATE_TASK_RULE_FAILURE] =
  createRequestTypes(prefix, 'CREATE_TASK_RULE')

export const createTaskRule = createAction((projectId: string | null, data: ITaskRuleInput) => ({
  type: [CREATE_TASK_RULE_REQUEST, CREATE_TASK_RULE_SUCCESS, CREATE_TASK_RULE_FAILURE],
  promise: (api: IApi) => api.taskRules.create(projectId, data),
}))

export const [UPDATE_TASK_RULE_REQUEST, UPDATE_TASK_RULE_SUCCESS, UPDATE_TASK_RULE_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_TASK_RULE')

export const updateTaskRule = createAction((id: string, data: Partial<ITaskRuleInput>) => ({
  type: [UPDATE_TASK_RULE_REQUEST, UPDATE_TASK_RULE_SUCCESS, UPDATE_TASK_RULE_FAILURE],
  promise: (api: IApi) => api.taskRules.update(id, data),
}))

// One slice serves every scope, so a closed modal clears it before another scope opens.
export const RESET_TASK_RULES = `${prefix}/RESET_TASK_RULES`

export const resetTaskRules = () => ({
  type: RESET_TASK_RULES,
})

export const [DELETE_TASK_RULE_REQUEST, DELETE_TASK_RULE_SUCCESS, DELETE_TASK_RULE_FAILURE] =
  createRequestTypes(prefix, 'DELETE_TASK_RULE')

export const deleteTaskRule = createAction((id: string) => ({
  type: [DELETE_TASK_RULE_REQUEST, DELETE_TASK_RULE_SUCCESS, DELETE_TASK_RULE_FAILURE],
  promise: (api: IApi) => api.taskRules.delete(id),
}))
